import React, { useState, Fragment, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import DragZone from 'components/Shared/DragZone';
import { useDropzone } from 'react-dropzone';
import { NextBtn, BackBtn } from 'components/Shared/Button';
import { useForm } from 'react-hook-form';
import useReferenceComponent from 'hooks/useReferenceComponent';
import ReferenceDocument from '../ReferenceDocument';
import { Col, Row, FormFeedback, Input, Form, FormGroup, Label } from 'reactstrap';
import { StepContainer } from './StepContainer';
const fileTypes = ['.doc', '.docx', 'application/pdf', '.xlsx', '.xls'];

const SourceStep = ({ handleBack, onComplete, showReference }) => {
    const { t } = useTranslation();
    const { register, handleSubmit, setValue, errors } = useForm({
        shouldFocusError: false,
    });
    const [file, setFile] = useState(null);
    const [isFileTooLarge, setIsFileTooLarge] = useState(null);
    const [reference, handleRefChange] = useReferenceComponent();

    const { open, getInputProps } = useDropzone({
        accept: fileTypes,
        maxSize: 25000000,
        noKeyboard: true,
        multiple: false,
        onDropAccepted: (file) => {
            handleFile(file);
        },
        onDrop: (file) => {
            handleFile(file);
        },
    });

    const handleFile = async (fileArr) => {
        if (!fileArr[0]) return;
        setValue('name', fileArr[0].name);
        setFile(fileArr[0]);
        setIsFileTooLarge(false)
    };

    const handleOnSubmit = (data) => {
        if (data && file) {
            if (reference.join && reference.documentMissing) {
                return;
            }
            onComplete({ ...data, file: file }, reference);
            setFile(null);
        }
    };
    return (
        <StepContainer
            className="sidebar-new-contract-height"
            title={t('contracts.new.source_file')}
            form={
                <>
                    {!file ? (
                        <DragZone
                            imgSrc="/images/listing/createDocument/subir.svg"
                            label={t('common.drag_file')}
                            className=""
                            maxSize={25_400_000}
                            acceptedFiles={fileTypes}
                            handleFile={handleFile}
                            onDropRejected={(rejected) => {
                                const { errors } = rejected?.[0] || {}
                                if (errors?.[0].code === 'file-too-large') {
                                    setIsFileTooLarge(true);
                                }
                            }}
                        />
                    ) : (
                        <p>
                            {file.name} - {file.size}
                        </p>
                    )}

                    <Form onSubmit={handleOnSubmit} className="mt-2">
                        <span className="font-weight-bold">{t('sign.contract.attachment_save')}</span>

                        {/* <div className="file_pragamtic_container" onClick={open}>
              <div className="file_name_wrap">
                <div>{file ? file.name : t("contracts.new.search_document")}</div>
              </div>
              <input {...getInputProps()} />
              <div className="upload-icon-container">
                <i className="fas fa-upload text-white"></i>
              </div>
            </div> */}

                        <FormGroup>
                            <Label className="font-weight-bold mb-3 mt-3">{t('contracts.new.name_title')}</Label>

                            <Input
                                name="name"
                                invalid={errors.name}
                                innerRef={register({ required: true })}
                                className="create-input mb-3"
                                placeholder={t('contracts.new.name_title')}
                            />
                            <FormFeedback invalid={errors.name}>{t('contracts.new.name_required')}</FormFeedback>
                            <div className="text-danger" hidden={!isFileTooLarge}>{t('errors.FileTooLarge')}</div>
                        </FormGroup>
                        <ReferenceDocument onChange={handleRefChange} reference={reference} showReference={showReference} />
                    </Form>
                </>
            }
            footer={
                <>
                    <BackBtn onClick={handleBack} label={t('form.exit')} />
                    <NextBtn onClick={handleSubmit(handleOnSubmit)} label={t('contracts.listing.page_next')} />
                </>
            }
        />
    );
};

export default SourceStep;
